import { render, staticRenderFns } from "./featured.vue?vue&type=template&id=746d85df&scoped=true&"
import script from "./featured.vue?vue&type=script&lang=js&"
export * from "./featured.vue?vue&type=script&lang=js&"
import style0 from "./featured.vue?vue&type=style&index=0&id=746d85df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d85df",
  null
  
)

export default component.exports